import {Avatar, Box, Container, Divider, Typography} from "@mui/material";
import {motion} from "framer-motion";

const LandingHero = () => {
    const specialties = ["Senior Unity Engineer", "Technical Lead", "Mobile Game Developer"];
    return (
        <Container>
            <Box
                sx={{
                    // height: {xs: "50dvh", sm: "50dvh", md: "100dvh", lg: "100dvh"},
                    alignContent: "center",
                    alignItems: "center",
                    px: {xs: 3, md: 6},
                    textAlign: "left",
                    marginTop: "25px",
                    // minHeight: "400px",
                    color: "white",
                }}
            >
                <Box sx={{
                    width: "100%",
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",

                }}>
                    {/* Left: Name & Titles */}
                    <Box>
                        <motion.div
                            initial={{opacity: 0, y: -50}}
                            animate={{opacity: 1, y: 0}}
                            transition={{duration: 1, ease: "easeOut"}}
                        >
                            <Typography
                                variant="h2"
                                sx={{
                                    fontWeight: 900,
                                    fontSize: {xs: "2rem", sm: "3rem", md: "4rem"},
                                    fontFamily: `"Poppins", sans-serif`,
                                }}
                            >
                                Konstantinos Panteli
                            </Typography>
                        </motion.div>
                        {/* Specialties - Fade-in Slam Effect */}
                        <Box sx={{mt: 1}}>
                            {specialties.map((title, index) => (
                                <motion.div
                                    key={index}
                                    initial={{opacity: 0, y: 20, scale: 0.9}}
                                    animate={{opacity: 1, y: 0, scale: 1}}
                                    transition={{
                                        delay: index * 0.4,
                                        duration: 0.5,
                                        ease: "easeOut",
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontSize: {xs: "1rem", md: "1.5rem"},
                                            color: "#FFD700", // Faint Gold
                                            fontFamily: `"Poppins", sans-serif`,
                                        }}
                                    >
                                        {title}
                                    </Typography>
                                </motion.div>
                            ))}
                        </Box>
                    </Box>
                    {/* Right: Profile Image */}
                    <motion.div
                        initial={{opacity: 0, scale: 0.8}}
                        animate={{opacity: 1, scale: 1}}
                        transition={{duration: 1, ease: "easeOut"}}
                    >
                        <Avatar
                            src="/images/konstantinos.jpg"
                            alt="Konstantinos Panteli"
                            sx={{
                                width: {xs: 80, sm: 120, md: 150},
                                height: {xs: 80, sm: 120, md: 150},
                                border: "4px solid rgba(255, 215, 0, 0.3)", // Subtle Gold Border
                            }}
                        />
                    </motion.div>
                </Box>
                {/* Bio Section */}
                <Box sx={{ width: "100%", mt: 4 }}>
                    {/* BIO Title with Underline */}
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            fontFamily: `"Poppins", sans-serif`,
                            display: "inline-block",
                            fontSize: {xs: '14px', md:'24px'},
                        }}
                    >
                        Bio
                    </Typography>
                    <Divider
                        sx={{
                            backgroundColor: "#FFD700", // Faint Gold Underline
                            height: "2px",
                            width: "50px",
                            mt: 1,
                        }}
                    />

                    {/* Bio Text */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 1.5, duration: 0.8, ease: "easeOut" }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                mt: 2,
                                color: "#ccc",
                                fontSize: { xs: "0.9rem", md: "1.1rem" },
                                lineHeight: 1.5,
                                fontFamily: `"Poppins", sans-serif`,
                            }}
                        >
                            Senior Unity engineer and technical lead based in Limassol, Cyprus, with 7+ years of Unity/C# experience building mobile games and cross-platform interactive products.
                            I focus on Unity architecture, real-time client systems, native iOS/Android integrations, mobile performance, Firebase, REST APIs, live game systems, and production tooling.
                            Currently, I lead Unity client engineering at BrainRocket while staying hands-on with architecture, code quality, delivery, and production code.
                        </Typography>
                    </motion.div>
                </Box>
            </Box>
        </Container>
    );
}

export default LandingHero;
